import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function AgAs() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tDate, setTDate] = useState(""); // End date
  const [showData, setShowData] = useState(false);

  const fetchData = async () => {
    if (!tDate) {
      alert("Please select a date.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://U1.hunzagroupofindustries.com.pk/api/YardAsOn/GetASON?tDate=${tDate} &compid=1`
      );
      if (!response.ok) throw new Error("Failed to fetch data");
      const result = await response.json();
      setData(result);
      setShowData(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (num) => Intl.NumberFormat().format(num);

  const calculateTotals = (group) => {
    const groupData = data.filter((item) => item.Period === group);
    const totalPayableWeight = groupData.reduce((sum, item) => sum + item.PWt, 0);
    const totalCost = groupData.reduce((sum, item) => sum + item.Cost, 0);
    const avgCostPer40Kg = (totalCost / totalPayableWeight) * 40 || 0;
    return { totalPayableWeight, totalCost, avgCostPer40Kg };
  };

  return (
    <div className="container-fluid px-3">
      <h3 className="text-center mb-4">Average Cost </h3>

      {/* Date Selection Input */}
      <div className="row mb-4">
        <div className="col-12 col-lg-6 offset-lg-3">
          <label htmlFor="tDate" className="form-label">
            Select Date:
          </label>
          <input
            type="date"
            id="tDate"
            className="form-control"
            value={tDate}
            onChange={(e) => setTDate(e.target.value)}
          />
          <button
            className="btn btn-primary w-100 mt-3"
            onClick={fetchData}
            disabled={loading}
          >
            {loading ? "Loading..." : "Show Data"}
          </button>
        </div>
      </div>

      {/* Error State */}
      {error && (
        <div className="alert alert-danger d-flex justify-content-between align-items-center mt-4">
          <span>{error}</span>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              setError(null);
              setShowData(false);
            }}
          >
            Retry
          </button>
        </div>
      )}

      {/* Data Table */}
      {showData && !loading && data.length > 0 && (
        <div className="table-responsive mt-4">
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-dark">
              <tr>
                <th>Costing Type</th>
                <th className="text-end">Payable Weight (Kgs.)</th>
                <th className="text-end">Cane Amount (Rs.)</th>
                <th className="text-end">Avg. Cost / 40Kg (Rs.)</th>
              </tr>
            </thead>
            <tbody>
              {["1Prev", "2OnDate", "3ToDate"].map((group) => {
                const totals = calculateTotals(group);
                const groupName =
                  group === "1Prev"
                    ? "Previous"
                    : group === "2OnDate"
                    ? "On Date"
                    : "To Date";
                const groupClass =
                  group === "1Prev"
                    ? "table-primary"
                    : group === "2OnDate"
                    ? "table-danger"
                    : "table-info";

                return (
                  <React.Fragment key={group}>
                    <tr className={groupClass}>
                      <td colSpan="4" className="text-center">
                        <strong>{groupName}</strong>
                      </td>
                    </tr>
                    {data
                      .filter((item) => item.Period === group)
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{item.CostingType}</td>
                          <td className="text-end">
                            {formatNumber(item.PWt)}
                          </td>
                          <td className="text-end">
                            {formatNumber((item.Cost || 0).toFixed(2))}
                          </td>
                          <td className="text-end">
                            {formatNumber(item.AvgCost.toFixed(2))}
                          </td>
                        </tr>
                      ))}
                    <tr className={groupClass}>
                      <td>
                        <strong>({groupName}) Summary</strong>
                      </td>
                      <td className="text-end">
                        <strong>{formatNumber(totals.totalPayableWeight)}</strong>
                      </td>
                      <td className="text-end">
                        <strong>{formatNumber(totals.totalCost.toFixed(2))}</strong>
                      </td>
                      <td className="text-end">
                        <strong>{formatNumber(totals.avgCostPer40Kg.toFixed(2))}</strong>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* No Data Available */}
      {showData && !loading && data.length === 0 && (
        <div className="alert alert-warning text-center mt-4">
          No data available for the selected date.
        </div>
      )}
    </div>
  );
}

export default AgAs;
